import { schemes, zSchema } from "@zeal/common";

const employeeAccrualBalanceWLSchema = zSchema.object({
  employeeID: schemes.mongoObjectId(),
  accrual_balance: zSchema.number(),
});

export const patchAccrualBalanceWLRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  id: schemes.mongoOrUuid(),
  employees: zSchema.array(employeeAccrualBalanceWLSchema),
});

export type TPatchAccrualBalanceWLRequestSchema = zSchema.infer<
  typeof patchAccrualBalanceWLRequestSchema
>;

export const patchAccrualBalanceWLResponseSchema = zSchema.object({
  id: schemes.mongoOrUuid(),
  companyID: schemes.companyID(),
  employees: zSchema.array(employeeAccrualBalanceWLSchema),
  invalid_employees: zSchema.array(zSchema.string()).optional(),
});

export type TPatchAccrualBalanceWLResponseSchema = zSchema.infer<
  typeof patchAccrualBalanceWLResponseSchema
>;
